import React, { useState } from 'react';

const styles = {
  page: { minHeight: '100vh', background: '#FDF8F5', display: 'flex', flexDirection: 'column' },
  header: { display: 'flex', alignItems: 'center', gap: '16px', padding: '20px 32px', background: '#FFFFFF', borderBottom: '1px solid #EDE8E3' },
  backBtn: { background: '#F5F0EB', border: 'none', borderRadius: '999px', padding: '10px 20px', fontSize: '14px', fontWeight: 500, color: '#6B6B6B', cursor: 'pointer' },
  title: { fontSize: '18px', fontWeight: 600 },
  saveBtn: (ready) => ({ marginLeft: 'auto', background: ready ? 'linear-gradient(135deg, #F7C948, #F4A261)' : '#EDE8E3', border: 'none', borderRadius: '999px', padding: '12px 28px', fontWeight: 600, fontSize: '15px', color: ready ? '#2D2D2D' : '#A0A0A0', cursor: ready ? 'pointer' : 'default', transition: 'all 0.2s' }),
  content: { flex: 1, maxWidth: '720px', width: '100%', margin: '0 auto', padding: '40px 24px' },
  dateLabel: { fontSize: '13px', color: '#A0A0A0', marginBottom: '24px' },
  titleInput: { width: '100%', border: 'none', background: 'transparent', fontSize: '28px', fontFamily: "'Playfair Display', serif", fontWeight: 600, color: '#2D2D2D', outline: 'none', marginBottom: '24px', resize: 'none' },
  divider: { height: '1px', background: '#EDE8E3', marginBottom: '24px' },
  bodyInput: { width: '100%', border: 'none', background: 'transparent', fontSize: '17px', color: '#2D2D2D', outline: 'none', resize: 'none', lineHeight: 1.9, minHeight: '400px', fontFamily: 'Inter, sans-serif' },
  moodStrip: { display: 'flex', gap: '12px', marginTop: '40px', padding: '24px', background: '#FFFFFF', borderRadius: '20px', border: '1px solid #EDE8E3', alignItems: 'center' },
  moodLabel: { fontSize: '14px', color: '#6B6B6B', fontWeight: 500, marginRight: '8px' },
  moodBtn: (selected) => ({ width: '44px', height: '44px', borderRadius: '999px', border: selected ? '2px solid #F7C948' : '2px solid transparent', background: selected ? '#FFF3CD' : '#F5F0EB', fontSize: '22px', cursor: 'pointer', transition: 'all 0.15s', display: 'flex', alignItems: 'center', justifyContent: 'center' }),
};

const moods = ['😔', '😟', '😐', '🙂', '😊', '😄', '🤩'];

export default function JournalEntry({ navigate, userId }) {
  const [entryTitle, setEntryTitle] = useState('');
  const [body, setBody] = useState('');
  const [mood, setMood] = useState(null);
  const [saved, setSaved] = useState(false);

  const today = new Date().toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' });

  const handleSave = async () => {
    if (!body.trim()) return;
    try {
      await fetch('/api/entries', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ userId, content: `${entryTitle ? entryTitle + '\n\n' : ''}${body}`, moodScore: mood ? mood + 1 : null }),
      });
      setSaved(true);
      setTimeout(() => navigate('dashboard'), 1500);
    } catch (e) {
      console.error(e);
    }
  };

  if (saved) return (
    <div style={{ minHeight: '100vh', background: '#FDF8F5', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', gap: '16px' }}>
      <div style={{ fontSize: '64px' }}>✨</div>
      <div style={{ fontSize: '24px', fontFamily: "'Playfair Display', serif", fontWeight: 600 }}>Entry saved</div>
      <div style={{ color: '#A0A0A0' }}>Taking you back...</div>
    </div>
  );

  return (
    <div style={styles.page}>
      <div style={styles.header}>
        <button style={styles.backBtn} onClick={() => navigate('dashboard')}>← Back</button>
        <div style={styles.title}>New Entry</div>
        <button style={styles.saveBtn(body.trim())} onClick={handleSave}>Save entry</button>
      </div>
      <div style={styles.content}>
        <div style={styles.dateLabel}>{today}</div>
        <textarea style={styles.titleInput} placeholder="Give this moment a title..." value={entryTitle} onChange={e => setEntryTitle(e.target.value)} rows={1} />
        <div style={styles.divider} />
        <textarea style={styles.bodyInput} placeholder="What's on your mind? Write freely — this is your space..." value={body} onChange={e => setBody(e.target.value)} />
        <div style={styles.moodStrip}>
          <span style={styles.moodLabel}>How are you feeling?</span>
          {moods.map((emoji, i) => (
            <button key={i} style={styles.moodBtn(mood === i)} onClick={() => setMood(i)}>{emoji}</button>
          ))}
        </div>
      </div>
    </div>
  );
}
